import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { SystemUserRole } from '@inshuwa-client/models';

export const loginGuard = () => {
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return false;
  }

  const { role } = decoded;

  return (
    role.toLowerCase() === SystemUserRole.PartnerRepresentative.toLowerCase() ||
    role.toLowerCase() ===
      SystemUserRole.AdminPartnerRepresentative.toLowerCase()
  );
};
